import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_5m0xhjob5o: FaireBrandEntity = {
  token: "b_5m0xhjob5o",
  type: "brand",
  name: "Candlefy",
  avatarUrl:
    "https://cdn.faire.com/fastly/eb41382ff91746197096e7f5c1c13600682ba6e226e5ef492c42c8c2d2399be0.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/f1927ebf7c3d5b9d29fc919c696a6386e94ff1ccddbf06d7ee9ab79b3f1f2551.webp",
  logoUrl:
    "https://cdn.faire.com/fastly/eb41382ff91746197096e7f5c1c13600682ba6e226e5ef492c42c8c2d2399be0.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/f1927ebf7c3d5b9d29fc919c696a6386e94ff1ccddbf06d7ee9ab79b3f1f2551.webp",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 129,
  rating: 5,
  reviewCount: 164,
  isTopShop: true,
  isInsider: true,
  description:
    "Candlefy creates clean-burning home fragrance designed for everyday living. \n\nHand-poured in Southern California, our candles, room sprays, reed diffusers and wax melts combine premium ingredients with approachable pricing - making quality scent experiences accessible to a wide range of customers.\n\nInspired by the coastal landscapes, mountains and open spaces surrounding our studio, our fragrances are crafted to feel fresh, balanced and easy to live with. From calming greens and soft woods to warm amber and modern florals, each scent is designed to create a welcoming atmosphere at home.\n\nWe use coconut apricot wax, phthalate-free fragrance oils and domestically sourced materials whenever possible. Every product is made in the USA with a focus on consistency, clean burn performance and retail-ready presentation.\n\nCandlefy products are designed for strong sell-through: warm amber vessels, modern minimal labels, and universally appealing scents that merchandise easily across lifestyle, gift, and home décor environments.\n\nOur goal is simple: to offer premium home fragrance that feels elevated, approachable and easy to love.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:32.757Z",
    importedBy: "entity-db-cli",
  },
};
